import { useSelector } from 'react-redux';

import { RootState } from 'store';

import { STATIONS_STATE } from '../../constants';

export const useSelectedStationOnMap = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].selectedStationOnMap)
);
